import { CategoriesGrid } from '../components/CategoriesGrid'
import { EModeCategoryTile } from '../components/EModeCategoryTile'
import { EModeOverviewPanel } from '../components/EModeOverviewPanel'
import { EModeCategory, PositionOverview } from '../types'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { EModeCategoryName } from '@/features/sparklend/common/data/market-info/emode'
import { RiskAcknowledgementInfo } from '@/features/sparklend/common/utils/liquidation-risk-warning/types'
import {
  SetUserEModeValidationIssue,
  setUserEModeValidationIssueToMessage,
} from '@/features/sparklend/common/validation/validateSetUserEMode'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { links } from '@/ui/constants/links'
import { Alert } from '@/ui/molecules/alert/Alert'
import { RiskAcknowledgement } from '@/ui/organisms/risk-acknowledgement/RiskAcknowledgement'

interface EModeViewProps {
  eModeCategories: Record<EModeCategoryName, EModeCategory>
  selectedEModeCategoryName: EModeCategoryName
  validationIssue?: SetUserEModeValidationIssue
  actionsViewState: ActionsViewState
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
  riskAcknowledgement: RiskAcknowledgementInfo
  showActions: boolean
}

export function EModeView({
  eModeCategories,
  selectedEModeCategoryName,
  validationIssue,
  actionsViewState,
  currentPositionOverview,
  updatedPositionOverview,
  riskAcknowledgement,
  showActions,
}: EModeViewProps) {
  return (
    <MultiPanelDialog>
      <div className="flex flex-col gap-3">
        <DialogTitle>Set E-Mode Category</DialogTitle>
        <p className="typography-body-3 text-secondary">
          E-Mode allows you to borrow assets belonging to the selected category.
          <br />
          Please visit our <ExternalLink to={links.docs.eMode}>FAQ guide</ExternalLink> to learn more about how it works
          and the applied restrictions.
        </p>
      </div>

      <CategoriesGrid>
        {Object.values(eModeCategories).map((eModeCategory) => (
          <EModeCategoryTile key={eModeCategory.name} eModeCategory={eModeCategory} />
        ))}
      </CategoriesGrid>

      <EModeOverviewPanel
        eModeCategory={eModeCategories[selectedEModeCategoryName]}
        currentPositionOverview={currentPositionOverview}
        updatedPositionOverview={updatedPositionOverview}
      />

      {validationIssue && <Alert variant="error">{setUserEModeValidationIssueToMessage[validationIssue]}</Alert>}

      {riskAcknowledgement.warning && (
        <RiskAcknowledgement
          onStatusChange={riskAcknowledgement.onStatusChange}
          warning={riskAcknowledgement.warning}
        />
      )}

      {showActions && (
        <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
      )}
    </MultiPanelDialog>
  )
}
